import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { Backdrop, Button, CircularProgress, Container } from "@mui/material";
import Swal from "sweetalert2";
import GetAuth from "../../../GetAuth";
import { ref, child, get, getDatabase, set } from "firebase/database";

const MoreLinksManage = () => {
	const [submitting, setSubmitting] = useState(false);

	const [info, setInfo] = useState();
	const dbRef = ref(getDatabase(GetAuth()?.auth));
	const [load, setLoad] = useState();
	useEffect(() => {
		get(child(dbRef, "josettehill")).then((snapshot) => {
			setLoad(snapshot.val());
			setInfo(snapshot.val()?.moreLinks);
			setFields(snapshot.val()?.moreLinks?.fields);
		});
	}, [dbRef]);

	const Submit = () => {
		setSubmitting(true);
		const data = {
			fields,
			submitTime: new Date().toLocaleString(),
		};
		set(child(dbRef, "josettehill"), { ...load, moreLinks: data })
			.then(function (response) {
				setSubmitting(false);
				Swal.fire({
					icon: "success",
					title: "Successfully Updated",
					showConfirmButton: false,
					timer: 1500,
				});
			})
			.catch(function (error) {
				console.log(error);
			});
	};
	const [fields, setFields] = useState([
		{
			link: "",
			title: "",
		},
	]);
	const handleAddFields = () => {
		setFields([...fields, { link: "", title: "" }]);
	};
	const handleDeleteFields = (index) => {
		const newTimes = [...fields];
		newTimes.splice(index, 1);
		setFields(newTimes);
	};
	const handleFieldsChange = (e, index, key) => {
		const newTimes = [...fields];
		newTimes[index][key] = e.target.value;
		setFields(newTimes);
	};

	return (
		<Container sx={{ pt: 1 }}>
			<Typography
				variant='h4'
				gutterBottom
				className='textColor'
				sx={{ fontWeight: "bold" }}>
				More Links
			</Typography>
			<Typography sx={{ pb: 2 }} className='textColor'>
				Last changed in {info?.submitTime || "N/A"}
			</Typography>
			<div>
				<Grid container spacing={3}>
					{fields.map((f, index) => (
						<Grid item xs={12} key={index} sx={{ display: "flex" }}>
							<TextField
								required
								name='link'
								label='link'
								fullWidth
								InputLabelProps={{
									shrink: true,
								}}
								value={f.link}
								onChange={(e) => handleFieldsChange(e, index, "link")}
							/>
							<TextField
								required
								name='title'
								label='link Title'
								fullWidth
								InputLabelProps={{
									shrink: true,
								}}
								value={f.title}
								onChange={(e) => handleFieldsChange(e, index, "title")}
							/>

							<button onClick={() => handleDeleteFields(index)}>Delete</button>
						</Grid>
					))}
				</Grid>
				<Button
					onClick={Submit}
					sx={{
						my: 2,
						border: "1px solid",
					}}>
					Save
				</Button>
				<Button onClick={handleAddFields} sx={{ my: 2, border: "1px solid" }}>
					+ Add More
				</Button>
			</div>

			<Backdrop
				sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={submitting || !load}>
				<CircularProgress color='inherit' />
			</Backdrop>
		</Container>
	);
};

export default MoreLinksManage;
